module.exports = __webpack_public_path__ + "static/media/AzureFunctions.a0694147.png";